import { createSlice } from '@reduxjs/toolkit';

const groupsSlice = createSlice({
  name: 'groups',
  initialState: {
    groups: [],
    currentGroup: null,
    loading: false,
    error: null,
  },
  reducers: {
    setGroups: (state, action) => {
      state.groups = action.payload;
      state.loading = false;
      state.error = null;
    },
    addGroup: (state, action) => {
      state.groups.unshift(action.payload);
    },
    updateGroup: (state, action) => {
      const index = state.groups.findIndex(g => g._id === action.payload._id);
      if (index !== -1) {
        state.groups[index] = { ...state.groups[index], ...action.payload };
      }
      if (state.currentGroup?._id === action.payload._id) {
        state.currentGroup = { ...state.currentGroup, ...action.payload };
      }
    },
    removeGroup: (state, action) => {
      state.groups = state.groups.filter(g => g._id !== action.payload);
      if (state.currentGroup?._id === action.payload) {
        state.currentGroup = null;
      }
    },
    setCurrentGroup: (state, action) => {
      state.currentGroup = action.payload;
    },
    updateGroupUnread: (state, action) => {
      const { groupId, unreadCount } = action.payload;
      const group = state.groups.find(g => g._id === groupId);
      if (group) {
        group.unreadCount = unreadCount;
      }
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    clearError: (state) => {
      state.error = null;
    },
  },
});

export const {
  setGroups,
  addGroup,
  updateGroup,
  removeGroup,
  setCurrentGroup,
  updateGroupUnread,
  setLoading,
  setError,
  clearError,
} = groupsSlice.actions;

export default groupsSlice.reducer;
